import momentjs from 'moment-jalaali';
export * from './booking';
import './prototypeModifier';

const DATE_FORMAT_MOMENT_SHAMSI = 'YYYY-MM-DD';
const DATE_FORMAT_MOMENT_SHAMSI_JALALI = 'jYYYY-jMM-jDD';

export const checkNationalCode = (nationalCode) => {
  if (isNaN(nationalCode)) {
    return false;
  } else if (nationalCode == '') {
    console.log('nationalCode is empty');
    return false;
  } else if (nationalCode.length < 10 || nationalCode.length > 10) {
    console.log('nationalCode is lenght<10');

    return false;
  } else {
    if (!/^\d{10}$/.test(nationalCode)) return false;
    const check = +nationalCode[9];
    const sum =
      nationalCode
        .split('')
        .slice(0, 9)
        .map((x, i) => +x * (10 - i))
        .reduce((x, y) => x + y) % 11;
    return sum < 2 ? check == sum : check + sum == 11;
  }
};
export const checkMobileDevice = () => {
  if (
    // /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    //   navigator.userAgent,
    // ) ||
    // /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
    //   navigator.userAgent.substr(0, 4),
    // )
    window.matchMedia('(max-width: 767px)').matches
  )
    return true;
  else return false;
};
export const checkFlightType = (flightType) => {
  return ['OnewayTrip', 'RoundTrip'].indexOf(flightType) === -1;
};
export const checkPassengerCount = (adultCount, childCount) => {
  return adultCount === '0' && adultCount === childCount;
};

export const checkDateReturnDate = (flightType, flightDate) => {
  flightDate = flightDate.replace(/\./g, '/').split('-');

  if (!compareDate([flightDate[0], Date.now()])) return true;
  else if (flightType === 'RoundTrip') return compareDate(flightDate);
};
export const compareDate = (dateList) => {
  return new Date(dateList[0]) > new Date(dateList[1]);
};
export const redirectToDatepicker = (props) => {
  let url = props.location.pathname.split('/');
  url.splice(url.length - 1, 1);
  props.navigate(url.join('/'));
};

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function convertDate(date, src, to) {
  try {
    if (date) if (src === to) return date;
    if (to === 'fa')
      return momentjs(
        new Date(date).toISOString(),
        DATE_FORMAT_MOMENT_SHAMSI,
      ).format(DATE_FORMAT_MOMENT_SHAMSI_JALALI);
    else if (to === 'en')
      return momentjs(date, DATE_FORMAT_MOMENT_SHAMSI_JALALI).format(
        DATE_FORMAT_MOMENT_SHAMSI,
      );
    else return '---';
  } catch {
    return '---';
  }
}
export function capitalize(string) {
  return string.replace(/^\w/, (c) => c.toUpperCase());
}

export function convertEnumValueToTitle(enumData, enumValue, name, alternate) {
  if (enumValue === undefined || enumValue === null || enumValue === '') {
    return '';
  }
  const item = enumData.find((x) => x.value === enumValue);
  return (
    item &&
    (typeof item.title === 'object'
      ? item.title[name] || item.title[alternate]
      : item.title)
  );
}

export function convertEnumValueToMaxValue(enumData, enumValue) {
  if (!enumValue) {
    return '';
  }
  return enumData.find((x) => x.value === enumValue).maxValue;
}

export const Conditional = ({ checkRender, children }) => {
  return !!checkRender && children;
};

/**
 * filterElement structure
 * @param {[{}]} filterElements array of objects
 * @param {object} filterElementsItem each item in array
 * @param {String} filterElementsItem.key
 * @param {String} filterElementsItem.value
 */
export function generateFilterString(filterElements) {
  let query = '';
  filterElements.map(({ key, value }, index) => {
    if (value)
      if (typeof value !== 'object') {
        query += `${query.length && index !== 0 ? ',' : ''}"${key}":"${value}"`;
      } else if (value.join(',').length) {
        query += `${
          query.length && index !== 0 ? ',' : ''
        }"${key}":[${value.map((x) => `"${x.trim()}"`)}]`;
      }
  });
  if (query.length) return `{${query}}`;
  else return '{}';
}

export function debouncing(func, delay) {
  let debouncingTimer;
  return function (...args) {
    const context = this;
    clearTimeout(debouncingTimer);
    debouncingTimer = setTimeout(() => func.apply(context, args), delay);
  };
}
